<!-- 销售订单 -->
<template>
   <div class='page_content'>
      <div class="page_content_top">
         <v-button :buttonList="buttonList" @actionSet="actionSet" :buttonFlag="false" :showRefresh="true" @getPageInfo="getPageInfo"></v-button>
         <div class="page_content_top_line">
            <v-search v-if="pageShowData.searchList" :searchList="pageShowData.searchList" :getRequestData="getRequestData" @searchData="searchData" @openSearch="openSearch"></v-search>
         </div>
      </div>
      <div class="page_content_center">
         <el-table class="table1" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row size="mini">
            <!-- <el-table-column show-overflow-tooltip min-width="120" prop="QUAPERSON" label="审批人"></el-table-column> -->
            <el-table-column show-overflow-tooltip min-width="120" prop="bgmCode" label="商品编号"></el-table-column>
            <el-table-column show-overflow-tooltip min-width="120" prop="bgmName" label="通用名称"></el-table-column>
            <el-table-column show-overflow-tooltip min-width="120" prop="soec" label="规格"></el-table-column>
            <el-table-column show-overflow-tooltip min-width="120" prop="manufacturer" label="生产厂商"></el-table-column>
            <el-table-column show-overflow-tooltip min-width="120" prop="quaperson" label="审批人"></el-table-column>
            <el-table-column show-overflow-tooltip min-width="120" prop="quacheopi" label="审核意见"></el-table-column>
            <el-table-column show-overflow-tooltip min-width="120" prop="quachedate" label="审核时间"></el-table-column>
         </el-table>
      </div>
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
         <SearchScheme ref="searchScheme" :id="seId" :smId="cmId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../../byComponents/SearchScheme.vue"
import indexJS from './jsList';
export default {
   //import引入的组件需要注入到对象中才能使用
   components: { SearchScheme },
   data() {
      //这里存放数据
      return {
         tableHeight: 0,
         getRequestData: {
            start: '',	//开始上一个月
            end: '',	//当天最后时间
         },
         returnData: {
            pages: 0,  // 总页数
            total: 0,  // 总条数
            pageNum: 0,  // 当前页数
            list: []
         },
         sField: '',
         buttonList: [],
         pageShowData: indexJS,
         selectedDataIndex: 0,
         seTitle: "",//检索
         DialogVisible: false,
         seWidth: '0',
         seId: 0,
         cmId: 0,
         showStatus: false,
         actionData: {},
         parentSearchData: {},
         multipleSelection: [],
         selectOpm: false
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {
   },
   //方法集合
   methods: {
      // 检索Id, 索引(表格中), 标识
      openSearch({ sId, index, type, sField }) {
         this.DialogVisible = true
         this.seId = sId
         this.sField = sField
         if (type == 'opmName') {
            this.parentSearchData.opmAcceptor = 1
            this.parentSearchData.opmBuyer = ''
         }
         this.parentSearchData[type] = this.getRequestData[type]
      },
      //检索带回数据
      changeInputModel(val) {
         if (val != "" || val != undefined) {
            this.DialogVisible = false;
            this.paramValue(val)
         }
      },
      // 赋值字段
      paramValue(val) {
         let arr = this.sField.split(',')
         arr.forEach(item => {
            this.getRequestData[item] = val[item]
         })
      },
      getSeWidth(e) {
         this.seWidth = e + "%";
      },
      getWidth(e) {
         this.exWidth = e + "%";
      },
      getSearchName(e) {
         // console.log(e);
         this.seTitle = e;
      },
      async getPageInfo() {
         this.getDataList()
      },
      // 动作集合
      actionSet(actionData) {
      },
      // 数据搜索
      searchData() {
         this.getRequestData.page = 1
         this.getDataList()
      },

      // 获取数据列表
      async getDataList() {
         let responseData = await this.$http.refusequeryList(this.getRequestData)
         if (responseData && responseData.status == 200) {
            let resData = JSON.parse(JSON.stringify(responseData))
            this.returnData.list = resData.result
         } else {
            this.$message({
               message: responseData.message,
               type: 'error'
            });
         }
      },
      initTime() {
         this.getRequestData.start = this.$common.getStartTime()
         this.getRequestData.end = this.$common.getEndTime()
      },
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.getPageInfo()
      this.initTime()
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() {

   },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style  scoped>
.table_content_tag {
   margin-right: 1rem;
}

.el-tabs--border-card_new {
   height: 85vh;
   overflow-y: scroll;
}

::v-deep .table1 tr td:first-child .cell,
::v-deep .table1 tr th:first-child .cell {
   text-align: center;
}

::v-deep .table1 .el-checkbox__inner {
   width: 18px;
   height: 18px;
}

::v-deep .table1 .el-checkbox__inner::after {
   height: 8px;
   left: 6px;
   top: 2px;
   width: 5px;
}

::v-deep
   .table1
   .el-checkbox__input.is-indeterminate
   .el-checkbox__inner::before {
   height: 2px;
   left: 0;
   right: 0;
   top: 7px;
}
</style>
